import React from "react";
import MobileFooter from "./mobileFooter";
import DesktopFooter from "./desktopFooter";
import { Container, Hidden } from "@material-ui/core";
const Footer = () => {
  return (
    <div
      style={{
        boxShadow: "0px 0 5px rgba(0, 0, 0, 0.3)",
        paddingTop: 40,
        background: "white",
      }}
    >
      <Hidden mdUp>
        <MobileFooter></MobileFooter>
      </Hidden>
      <Hidden smDown>
        <DesktopFooter></DesktopFooter>
      </Hidden>
    </div>
  );
};
export default Footer;
